import type { GlobalFieldReference, Menu, Meta } from '@ps/web-martech-cms-types';
import type {
  BannerBlock,
  CasinoSecondaryNavigationBlock,
  ContextMenuBlock,
  CrmBlock,
  RotatorBlock
} from '@ps/web-martech-cms-types/Top';
import React from 'react';

import { CMSBanner, CMSReference, useCMSReference } from '@swf/cms';
import type { SportsQuickLinkBlock } from '@swf/sports/pages/types';

import useGeoVisibility from '../CMSContainer/hooks/useGeoVisibility';
import CMSRotator from '../CMSRotator/CMSRotator';

import ContextMenu from './components/ContextMenu/ContextMenu';

const TopBodyItem: React.FC<
  | BannerBlock
  | ContextMenuBlock
  | RotatorBlock
  | SportsQuickLinkBlock
  | CasinoSecondaryNavigationBlock
  | CrmBlock
  | GlobalFieldReference
> = (props) => {
  const banner = useCMSReference<Meta>((props as BannerBlock)?.banner?.reference[0]) as Meta;
  const visibilityRules = banner?.visibility_rules;
  const [isVisible] = useGeoVisibility(visibilityRules || []);
  const menu = useCMSReference<Menu>(
    (props as ContextMenuBlock).context_menu?.reference[0]
  ) as Menu;

  if ((props as RotatorBlock).rotator) {
    return <CMSRotator items={(props as RotatorBlock).rotator.reference} />;
  }
  if ((props as SportsQuickLinkBlock).sports_quick_links) {
    return <CMSReference {...(props as SportsQuickLinkBlock).sports_quick_links.reference[0]} />;
  }
  if ((props as CasinoSecondaryNavigationBlock).casino_secondary_navigation) {
    return (
      <CMSReference
        {...(props as CasinoSecondaryNavigationBlock).casino_secondary_navigation.reference[0]}
      />
    );
  }
  if ((props as CrmBlock).crm) {
    return <CMSReference {...(props as CrmBlock).crm.reference[0]} />;
  }
  if (isVisible && banner) return <CMSBanner {...banner.banner} />;
  if (menu) return <ContextMenu menu={menu} maxDepth={2} />;

  return <CMSReference {...(props as GlobalFieldReference)} />;
};

export default TopBodyItem;
